import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from '@mui/material';
import ErrorLayout from './ErrorLayout';
import { frontEndUrl, httpOnlySecurityService } from '../../../externals/iam';
import Button from '../../common/Button';

const UserConfigError = () => {
  const goLoginPage = () => {
    if (httpOnlySecurityService?.isUserAuthenticated()) {
      httpOnlySecurityService.logout();
      window.location.href = frontEndUrl;
    } else {
      window.location.href = 'https://sts.corp.ipc.be/adfs/oauth2/logout';
    }
  };

  const handleLogout = async () => {
    if (httpOnlySecurityService?.isUserAuthenticated()) {
      httpOnlySecurityService.logout();
    } else {
      window.location.href = 'https://sts.corp.ipc.be/adfs/oauth2/logout';
    }
  };

  return (
    <ErrorLayout>
      <Box padding="20px" display="flex" gap="10px">
        <Button type="button" onClick={goLoginPage}>
          <FormattedMessage id="app.errorBoundary.loginButton" />
        </Button>
        <Button marginLeft="15px" variant="default" onClick={handleLogout}>
          Logout
        </Button>
      </Box>
    </ErrorLayout>
  );
};

export default UserConfigError;
